import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type BetaAccessState = {
    accessLevel : {
        accessGranted : boolean
    }
}

const initialState : BetaAccessState = {
    accessLevel: {
        accessGranted: false
    }
}

export const betaAccessSlice = createSlice({
    name: 'betaAccess',
    initialState: initialState,
    reducers: {
        updateAccess: (state, action : PayloadAction<boolean>) => {
            state.accessLevel.accessGranted = action.payload;
        }
    }
});

export const {
    updateAccess
} = betaAccessSlice.actions;

export default betaAccessSlice.reducer;